import { render, staticRenderFns } from "./reviewDetail.vue?vue&type=template&id=2b36ee08&scoped=true"
import script from "./reviewDetail.vue?vue&type=script&lang=js"
export * from "./reviewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36ee08",
  null
  
)

export default component.exports